import actions from "./actions";

const initState = {
  classificationInfo: {},
  classifications: {
    data: [],
  },
  loading: false,
  classificationDeleted: false,
};

export default function fetchClassificationsReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_CLASSIFICATIONS_REQUESTED:
    case actions.SEARCH_CLASSIFICATION_REQUESTED:
      return {
        ...state,
        classifications: {
          data: [],
        },
        classificationInfo: {},
        loading: true,
      };
    case actions.FETCH_CLASSIFICATIONS_SUCCEEDED:
    case actions.SEARCH_CLASSIFICATION_SUCCEEDED:
      return {
        ...state,
        classifications: action.classifications,
        loading: false,
        classificationDeleted: false,
      };
    case actions.FETCH_CLASSIFICATIONS_FAILED:
    case actions.SEARCH_CLASSIFICATION_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.FETCH_CLASSIFICATION_REQUESTED:
      return {
        ...state,
        classificationInfo: {},
        loading: true,
      };
    case actions.FETCH_CLASSIFICATION_SUCCEEDED:
      return {
        ...state,
        classificationInfo: action.classification,
        loading: false,
      };
    case actions.FETCH_CLASSIFICATION_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.DELETE_CLASSIFICATION_REQUESTED:
      return {
        ...state,
        loading: true,
        classificationDeleted: false,
      };
    case actions.DELETE_CLASSIFICATION_SUCCEEDED:
      return {
        ...state,
        loading: false,
        classificationDeleted: true,
      };
    case actions.DELETE_CLASSIFICATION_FAILED:
      return {
        ...state,
        loading: false,
        classificationDeleted: false,
      };
    default:
      return state;
  }
}
